export default "__VITE_ASSET__Ca_hRlJ9__"